<template>
	<el-cascader v-model="regionValue" :options="region" :checkStrictly="true" @change="changeRegion" @visible-change="visible_change" :style="{width: cascaderWidth}">
		<span slot="empty">加载中……</span>
	</el-cascader>
</template>

<script>
export default {
	name: 'select-industry',
	props: {
		autoLoad: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		clearable: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		collapseTags: {
			type: Boolean,
			default: () => {
				return true;
			}
		},
		deep: {
			type: Number,
			default: () => {
				return 0;
			}
		},
		width:{
			type:String,
			default:()=>{
				return "320px";
			}
		},
		placeholder: {
			type: String,
			default: () => {
				return '请选择';
			}
		},
		value: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {
			loading: true,
			selectConfig: {},
			level:0,
			cascaderWidth:"320px",
			region: [],
			regionValue: [],
			itemChecked: ''
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted() {
		this.selectConfig = {
			clearable: this.clearable,
			collapseTags: this.collapseTags,
			placeholder: this.placeholder
		};
		this.cascaderWidth = this.width;
		this.level = this.deep;
		this.regionValue = this.value;
		if(this.autoLoad){
			this.getRegionData();
		}
	},
	updated: function() {},
	methods: {
		visible_change(e) {
			if (e) {
				if (this.region.length < 1) {
					this.getRegionData();
				}
			}
		},
		changeRegion(e) {
			this.$emit('change', e);
		},
		getRegionData() {
			this.loading = true;
			this.$http.post('/server/index.php?m=components/cascaderRegion&a=getInfoList', { level: this.level }).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.region = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		}
	},
	watch: {
		deep: function(val) {
			this.level = val;
			this.getRegionData();
		},
		value: function(val) {
			this.regionValue = val;
		}
	}
};
</script>

<style></style>
